// API client for the Assessment admin student performance endpoints
// (/api/assessment/admin/students).
//
// Envelope: { data, isError, statusCode, errorMessage }; both endpoints return
// data as a page-or-detail object (see below). The backend sorts the full list
// in memory, so sortBy is limited to ALLOWED_SORT_BY (anything else falls back
// to lastActiveAt) and sortDir is "asc" or anything-else-means-desc.
import api from "../axiosInstance";

export { apiErrorMessage } from "./assessmentHierarchy";

const BASE = "/api/assessment/admin/students";

export const ALLOWED_SORT_BY = ["avgScorePercentage", "testsAttempted", "lastActiveAt", "studentName"];

export const STUDENT_STATUSES = ["ACTIVE", "EXPIRED", "PENDING", "REFUNDED", "FAILED"];

const unwrap = (res) => res.data?.data;

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""),
  );

// Page of { studentUserId, studentName, email, phoneNumber, courseIds[], courseNames[],
// categoryIds[], categoryNames[], status (ACTIVE|EXPIRED|PENDING|REFUNDED|FAILED),
// avgScorePercentage, testsAttempted, completionRate, lastActiveAt }. The list is every
// student holding a category entitlement (including ones with no attempts yet).
// Filters (all optional): courseId, categoryId, status, search (name / email / phone,
// case-insensitive contains).
export const listStudents = async ({ page = 0, size = 20, ...filters } = {}) => {
  const res = await api.get(BASE, { params: cleanParams({ ...filters, page, size }) });
  return unwrap(res) || { content: [], totalElements: 0 };
};

// courseId is REQUIRED; categoryId is optional and supplies the readiness target (without it
// the platform default of 85% is returned). Returns { studentUserId, studentName,
// avgScorePercentage, testsAttempted, completionRate, attempts: page of { testName,
// scorePercentage, startedAt, status }, readiness: { readinessPercentage,
// readinessTargetPercentage, testsAttempted, avgScorePercentage, topicsCoveredCount,
// totalTopicsInCourse, practiceQuestionsAnswered, strongTopics[], weakTopics[] } } where each
// topic is { topicId, topicName, subjectIds, subjectNames, percentCorrect }.
export const getStudentDetail = async (studentUserId, { courseId, categoryId, page = 0, size = 10 }) => {
  const res = await api.get(`${BASE}/${studentUserId}`, {
    params: cleanParams({ courseId, categoryId, page, size }),
  });
  return unwrap(res);
};
